import { IconButton, Menu, MenuItem, Popover, Tooltip } from '@mui/material';
import { useState } from 'react';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { fontSize } from '../../..';
interface AddCustomValueProps {
  propKey: string;
  disabled: boolean;
  tooltip?: string;
  onClick: (type:'parameter'|'static',datatype?: string) => void;
  enabledOptions?:string[]
}
function AddCustomValue({ propKey, disabled, tooltip, onClick,enabledOptions=[] }: AddCustomValueProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [subAnchorEl, setSubAnchorEl] = useState<null | HTMLElement>(null);
  const sourceTypeList = ['text', 'decimal', 'integer', 'boolean', 'date'];
  const HandleOpenPopOver = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleSubMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setSubAnchorEl(event.currentTarget);
  };
  const closeSubMenu = () => {
    setSubAnchorEl(null);
  };
  const closeMenu = () => {
    setAnchorEl(null);
    closeSubMenu();
  }
  const handleOptionsClick=(event: React.MouseEvent<HTMLElement>)=>{
    const type=event.currentTarget.dataset.type as 'parameter'|'static';
    const datatype=event.currentTarget.dataset.value;
    if(!type) return;
    onClick(type,datatype);
    closeMenu();
  }
  return (
    <>
      <Tooltip
        title={tooltip || 'Add Custom Date'}
        slotProps={{
          tooltip: {
            sx: {
              fontSize: '12px',
            },
          },
        }}
      >
        <IconButton size="small" onClick={HandleOpenPopOver} disabled={disabled}>
          <AddCircleOutlineIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Popover
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={closeMenu}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
      >
        <Menu
          id="lock-menu"
          open={!!anchorEl}
          anchorEl={anchorEl}
          onClose={closeMenu}
          slotProps={{
            list: {
              'aria-labelledby': 'lock-button',
              role: 'listbox',
            },
          }}
          sx={{
            '& .MuiMenu-paper': {
              boxShadow: '0px 2px 8px rgba(0,0,0,0.4)',
            },
          }}
        >
          <MenuItem
            onClick={handleSubMenuClick}
            sx={{
              width: '120px',
              padding: '3px 15px',
              fontSize: fontSize.small,
              backgroundColor: subAnchorEl ? '#f4f4f4' : 'transparent',
              '&:hover': {
                backgroundColor: '#40404',
              },
            }}
          >
            Static values
          </MenuItem>
          <MenuItem
            sx={{
              width: '120px',
              padding: '3px 15px',
              fontSize: fontSize.small,
              '&:hover': {
                backgroundColor: '#40404',
              },
            }}
          >
            Parameterized
          </MenuItem>

          <Menu
            open={!!subAnchorEl}
            anchorEl={subAnchorEl}
            onClose={closeSubMenu}
            anchorOrigin={{
              vertical: 'top',
              horizontal: -70,
            }}
            sx={{
              '& .MuiMenu-paper': {
                boxShadow: '0px 2px 8px rgba(0,0,0,0.15)',
              },
            }}
            slotProps={{
              list: {
                sx: {
                  '& .MuiMenuItem-root': {
                    py: 0,
                    fontSize: fontSize.extraSmall,
                  },
                },
              },
            }}
          >
            {sourceTypeList.map((item: any, index: number) => {
              return (
                <MenuItem
                  
                  disabled={enabledOptions.length > 0 ? !enabledOptions.includes(item) : false}
                  dense
                  data-value={item}
                  data-type="static"
                  key={index}
                  onClick={handleOptionsClick}
                >
                  {item}
                </MenuItem>
              );
            })}
          </Menu>
        </Menu>
      </Popover>
      {/* <Menu open={Boolean(anchorEl)} anchorEl={anchorEl} onClose={() => setAnchorEl(null)}>
        {sourceTypeList.map((type, index) => {
          return (
            <MenuItem
              key={index}
              sx={{ width: '7rem' }}
              disabled={!['integer', 'decimal'].includes(type)}
              value={type}
              onClick={() => {
                setAnchorEl(null);
                // dispatch(
                //   setSource(
                //     propKey,
                //     activeFlow,
                //     0,
                //     new Date().toISOString().split('T')[0],
                //     'date',
                //     0,
                //   ),
                // );
                // dispatch(setSource(propKey, activeFlow, 0, 3, 'integer', 1));
                // dispatch(setSource(propKey, activeFlow, 0, 'day', 'text', 2));
              }}
            >
              {type.replace(/\b\w/g, (char) => char.toUpperCase())}
            </MenuItem>
          );
        })}
      </Menu> */}
    </>
  );
}

export default AddCustomValue;
